module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc0",
    attrs: {
      "id": "fm1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#afm1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Introduction#asec1"
    }
  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001#ach1"
    }
  }, [_vm._v("Chapter 1: What Is Gastroparesis?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#asec2"
    }
  }, [_vm._v("What Causes Gastroparesis?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#asec3"
    }
  }, [_vm._v("Who Is Diagnosed with Gastroparesis?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter001#asec4"
    }
  }, [_vm._v("Treatment Options")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002#ach2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Your Digestive System")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter002#asec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nervous System")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter002#asec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Enteric Nervous System")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter002#asec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anatomy of the Digestive System")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter002#asec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stomach")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter002#asec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enzymes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003#ach3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Creating a Holistic Plan for Gastroparesis")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec10"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter003#asec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lifestyle Assessment")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec11"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter003#asec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Medical Support")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec12"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter003#asec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reducing Stress")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004#ach4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Your Personal Nutrition Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec13"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter004#asec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Remove Problem Foods")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec14"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter004#asec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Food Testing")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec15"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter004#asec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Supplementation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005#ach5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Pantry and Kitchen")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec16"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter005#asec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kitchen")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec17"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter005#asec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pantry")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006#ach6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec18"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006#asec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Healing Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec19"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec1#asec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bone Broth")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec20"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec2#asec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Chicken Broth")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec21"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec3#asec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Veggie Mineral Broth")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec22"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec4#asec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Miso Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec23"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec5#asec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic-Infused Ghee")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec24"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec6#asec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nourishing Rice Porridge (Congee)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec25"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec7#asec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boiled Yucca")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec26"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec8#asec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Polenta")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec27"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec9#asec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nourishing Meals")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec28"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec10#asec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec29"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec11#asec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Millet Cereal")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec30"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec12#asec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almond Flour Banana Squash Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec31"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec13#asec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot Ginger Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec32"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec14#asec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Squash Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec33"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec15#asec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kabocha Miso Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec34"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec16#asec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summertime Gazpacho")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec35"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec17#asec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec36"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec18#asec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vermicelli Noodle Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec37"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec21#asec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arepas with Minced Avocado Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec38"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec22#asec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chard and Red Pepper Egg Bites")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec39"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec23#asec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chawan Mushi (Steamed Egg)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec40"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec24#asec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saag Aloo")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec41"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec25#asec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkey Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec42"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec26#asec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asian-Style Ground Pork")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec43"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec27#asec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miso-Glazed Dover Sole")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec44"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec28#asec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec45"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec29#asec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salmon Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec46"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec30#asec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamed Parsnips with Parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec47"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec31#asec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baba Ganoush")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec48"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec32#asec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kohlrabi Mash")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec49"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec33#asec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Red Bell Peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec50"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec34#asec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Mash")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec51"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec35#asec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liver Puree")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec52"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec36#asec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pão De Queijo (Brazilian Cheese Bread)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec53"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec37#asec53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Almond Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec54"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec38#asec54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chip Almond Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec55"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec39#asec55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Avocado Key Lime Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec56"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec40#asec56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Avocado Chocolate Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec57"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec41#asec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soothing Sweetened Jellies")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec58"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec42#asec58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Banana Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec59"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec43#asec59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Electrolyte Drink")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec60"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec44#asec60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Almond Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec61"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec45#asec61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ginger Cinnamon Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec62"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec46#asec62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican Hot Chocolate")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec63"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec47#asec63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turmeric Ginger Almond Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec64"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec48#asec64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Fruit and Mint Yogurt Lassi")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec65"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter006sec49#asec65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Juiced Jicama")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter007#ach7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Holistic View of Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec66"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter007#asec66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Love")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec67"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter007#asec67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purpose")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec68"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter007#asec68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Environment")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter008#ach8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Nutrition 101")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec69"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter008#asec69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Macronutrients")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec70"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter008#asec70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Micronutrients")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "bm1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/AppendixA#abm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: Low-Fiber Foods")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "bm2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/AppendixB#abm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Increasing Stomach Acid Holistically")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "bm3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/AppendixC#abm3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: Goodies from GP Interviews")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1",
    attrs: {
      "id": "bm4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Resources#abm4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "bm5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Conversions#abm5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conversions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "bm6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments#abm6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "bm7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#abm7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99aa2174","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 69
// module chunks = 0